import { crossingTypes } from '../crossings/constants'
import { selectDepartureAndReturnVehicles } from '../vehicleSelections/selectors'
import { selectAvailableVehicleOptions } from '../configuration/selectors'
import { selectActiveModifyBooking } from '../modifyBooking/selectors'
import {
  getBookingVehicleByCrossingType,
  getVehicleByCode
} from '../vehicleSelections/utilities'

const selectInitialVehicleValues = state => {
  const selectedVehicles = selectDepartureAndReturnVehicles(state)
  let result = { ...selectedVehicles }

  const availableVehicles = selectAvailableVehicleOptions(state)
  const activeModifyBooking = selectActiveModifyBooking(state)

  const replaceWithBookingVehicles =
    activeModifyBooking &&
    (activeModifyBooking?.departureVehicleCode ||
      activeModifyBooking?.returnVehicleCode) &&
    availableVehicles

  if (replaceWithBookingVehicles) {
    const departureVehicle = getBookingVehicleByCrossingType({
      booking: activeModifyBooking,
      bookingVehicle: getVehicleByCode({
        availableVehicles,
        vehicleCode: activeModifyBooking?.departureVehicleCode
      }),
      crossingType: crossingTypes.DEPARTURE
    })
    const returnVehicle = getBookingVehicleByCrossingType({
      booking: activeModifyBooking,
      bookingVehicle: getVehicleByCode({
        availableVehicles,
        vehicleCode: activeModifyBooking?.returnVehicleCode
      }),
      crossingType: crossingTypes.RETURN
    })

    if (departureVehicle) result.departure = { ...departureVehicle }
    if (returnVehicle) result.return = { ...returnVehicle }
  }

  return result
}

export default selectInitialVehicleValues
